import React from 'react';
import { Button } from 'antd';
import { Link } from '@common/components';
import { buildDialogUrl } from '@common/services';

type Props = { applicationId: string };

export function ViewSubmissionDrawerButton({ applicationId }: Props) {
  const drawerUrl = buildDialogUrl('review-submission-drawer', {
    props: { applicationId },
  });

  return (
    <Link to={drawerUrl}>
      <Button>Submission</Button>
    </Link>
  );
}
